//展示管理
import http from '../jslibs/axios/http';

// 培训列表
export const getTrainList = data => http.get('/cms/Train', data);
// 新增培训
export const addTrain = data => http.post('/cms/Train', data);
//编辑培训
export const updateTrain = data => http.put('/cms/Train/' + data.uuid, data);
//培训详情
export const getTrainDetail = data => http.get('/cms/Train/' + data.uuid);
//删除培训
export const deleteTrain = data => http.delete('/cms/Train/' + data.uuid);
///培训推荐
export const addTrainRecommend = data => http.put('/cms/TrainRecommend/' + data.uuid,data);
//结束培训
export const TrainFinish = data => http.post('/cms/TrainFinish',data);


// 培训分类列表
export const getTrainCateList = data => http.get('/cms/TrainCate', data);
// 新增培训分类
export const addTrainCate = data => http.post('/cms/TrainCate', data);
//编辑培训分类
export const updateTrainCate = data => http.put('/cms/TrainCate/' + data.uuid, data);
//培训分类详情
export const getTrainCateDetail = data => http.get('/cms/TrainCate/' + data.uuid);
//删除培训分类
export const deleteTrainCate = data => http.delete('/cms/TrainCate/' + data.uuid);

